module.exports = __webpack_public_path__ + "static/media/edit_fills.a69524af.svg";